import {
  init,
  BrowserTracing,
  makeBrowserOfflineTransport,
  makeFetchTransport,
  configureScope
} from '@sentry/browser';
import { BaseTransportOptions } from '@sentry/types/types/transport';
import { isDev } from './isDev';


const transport = makeBrowserOfflineTransport((
  options: BaseTransportOptions,
  ) => makeFetchTransport({
    ...options,
    // masking sentry_key because adblockers use it for blocking sentry
    url: options.url.replace(/sentry_key/, 'xauth'),
  })
);

export function initSentry(serverHostname: string, environment: string): void {
    if (isDev()) {
        return;
    }
    init({
        dsn: `https://token@${serverHostname}/_report/1`,
        release: process.env.RELEASE_VERSION,
        // autoSessionTracking: false,
        transport,
        environment,
        integrations: [
          new BrowserTracing({
            tracePropagationTargets: ['localhost', new RegExp(environment)],
          }),
        ],
        tracesSampleRate: 1.0,
    });
    setOfflineTag();
}

export function setOfflineTag(val: 'no' | 'yes' = 'no') {
  configureScope((scope) => scope.setTag('offline', val));
}

